import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
}
export function Card({
  children,
  className = '',
  hover = false
}: CardProps) {
  return <div className={`bg-white rounded-xl border border-slate-200 p-6 ${hover ? 'transition-all duration-200 hover:shadow-lg hover:border-primary-light' : ''} ${className}`} data-id="element-315">
      {children}
    </div>;
}